import {
  A,
  Blockquote,
  Div,
  Em,
  H1,
  H2,
  H3,
  Hr,
  Li,
  Ol,
  P,
  Span,
  Strong,
  Ul,
} from '@scatterlab/zeta-core';
import { Components } from 'react-markdown';

export const MarkdownComponents: Partial<Components> = {
  h1: ({ children, node, ...props }) => (
    <H1 className="title24" {...props}>
      {children}
    </H1>
  ),
  h2: ({ children, node, ...props }) => (
    <H2 className="title20" {...props}>
      {children}
    </H2>
  ),
  h3: ({ children, node, ...props }) => (
    <H3 className="title18" {...props}>
      {children}
    </H3>
  ),
  strong: ({ children, node, ...props }) => (
    <Strong className="font-extrabold" {...props}>
      {children}
    </Strong>
  ),
  em: ({ children, node, ...props }) => (
    <Em className="pr-1 leading-[1.3em] text-white/50" {...props}>
      {children}
    </Em>
  ),
  blockquote: ({ children, node, ...props }) => (
    <Blockquote className="flex h-fit flex-row gap-[10px]" {...props}>
      <Div className="w-1 bg-white/50" />
      {children}
    </Blockquote>
  ),
  ol: ({ children, node, ...props }) => (
    <Ol className="list-outside list-decimal whitespace-normal pl-6" {...props}>
      {children}
    </Ol>
  ),
  ul: ({ children, node, ...props }) => (
    <Ul className="list-outside list-disc whitespace-normal pl-6" {...props}>
      {children}
    </Ul>
  ),
  li: ({ children, node, ...props }) => <Li {...props}>{children}</Li>,
  a: ({ children, node, ...props }) => (
    <A className="text-primary-200 underline" {...props}>
      {children}
    </A>
  ),
  hr: ({ children, node, ...props }) => (
    <Hr className="my-[10px] border-gray-700" {...props} />
  ),
  div: ({ children, node, ...props }) => <Div {...props}>{children}</Div>,
  span: ({ children, node, ...props }) => <Span {...props}>{children}</Span>,
  p: ({ children, node, ...props }) => <P {...props}>{children}</P>,
  del: ({ children, node, ...props }) => (
    <Span className="line-through" {...props}>
      {children}
    </Span>
  ),
};

export const CompactMarkdownComponents: Partial<Components> = {
  h2: ({ children, node, ...props }) => (
    <H2 className="body14 mb-4" {...props}>
      {children}
    </H2>
  ),
  h3: ({ children, node, ...props }) => (
    <H3 className="body12 mb-0.5" {...props}>
      {children}
    </H3>
  ),
  ul: ({ children, node, ...props }) => (
    <Ul {...props} className="mb-4 mt-1">
      {Array.isArray(children)
        ? children.filter((child) => child !== '\n')
        : children}
    </Ul>
  ),
  li: ({ children, node, ...props }) => (
    <Li className="body12 flex flex-row" {...props}>
      <Span className="mx-1.5 -mt-0.5 self-start">{'\u2022'}</Span>
      {children}
    </Li>
  ),
  div: ({ children, node, ...props }) => (
    <Div className="body12" {...props}>
      {Array.isArray(children)
        ? children.filter((child) => child !== '\n')
        : children}
    </Div>
  ),
  span: ({ children, node, ...props }) => (
    <Span className="body12" {...props}>
      {children}
    </Span>
  ),
  p: ({ children, node, ...props }) => (
    <P className="body12" {...props}>
      {children}
    </P>
  ),
};
